<template>
  <div class="ps-3 mt-2">
    <table
      class="table table-bordered table-hover table-responsive"
      style="cursor: pointer"
    >
      <thead>
        <tr class="bg-tr-color">
          <th>Bil</th>
          <th>Bud</th>
          <th>Salgsdato</th>
          <th>Leveringer</th>
        </tr>
      </thead>
      <tbody class="border-top-0">
        <tr
          v-for="lot in arrLots"
          :key="lot.id"
        >
          <td>
            <a :href="lot.href">
              <img
                v-if="!!lot.lot_image_id"
                :src="'/storage/' + lot.lot_image_id"
                class="img-fluid card-img"
                style="width: 70px"
                alt="car"
              >
              {{ lot.name }}
            </a>
          </td>
          <td>{{ lot.rate }}</td>
          <td>{{ lot.date_sold }}</td>
          <td>
            <button
              v-if="lot.canDelivery && !lot.isDelivered"
              class="btn btn-tooltip btn-primary"
              :data-tooltip="trans('invoices.tooltip')"
              data-toggle="modal"
              @click="setData(lot)"
            >
              {{ trans('order_deliveries.button_delivery') }}
            </button>
            <a
              v-else-if="lot.canDelivery"
              href="/my/deliveries"
            >
              {{ trans('order_deliveries.button_delivered') }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <SendOrderDeliveryModal
    modal-id="sendOrder"
    :deliveries="deliveries"
    :gire-text="gireText"
    :axess-disabled="axessDisabled"
    :error="error"
    @send="sendOrder"
    @change-address="change"
    @get-price="getPrice"
  />
  <PreloaderComponent :show="isLoading" />
</template>

<script>
import SendOrderDeliveryModal from "./v2/SendOrderDeliveryModal.vue";
// import SendOrderDeliveryModal from "./SendOrderDeliveryModal.vue";
import {Modal} from "bootstrap";
import PreloaderComponent from "../PreloaderComponent.vue";

export default {
  name: "ListPurchasesComponent",
  components: {PreloaderComponent, SendOrderDeliveryModal},
  props: {
    lots: {
      type: Array,
      default() {
        return []
      }
    },
    gireText: {
      type: String,
      default: ''
    },
    trackSendOrder: {
      type: Boolean,
      default: false,
      required: false,
    },
    axessDisabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoading: false,
      arrLots: this.lots,
      carId: null,
      responseMessage: '',
      errorMessage: '',
      isCustomAddress: false,
      deliveries: [],
    }
  },
  computed: {
    error() {
      return this.errorMessage;
    }
  },
  methods: {
    setData(lot) {
      const modalElement = document.getElementById('sendOrder');
      const targetModal = new Modal(modalElement);
      this.carId = lot.car_id;
      const params = {
        companyName: lot.companyName,
        zip: lot.zip,
        address: lot.address,
        city: lot.city,
        phone: lot.phone,
        contact: lot.contact
      };
      this.requestPrices(params).then(resp => {
        this.deliveries = resp.data.deliveries;
        targetModal.show();
      });
      this.errorMessage = '';

      if (this.trackSendOrder) {
        this.sendOrderLog()
      }
    },
    sendOrderLog() {
      axios({
        url: `?car_id=${this.carId}&Gire=open order window&metrics=true`,
        method: 'GET',
      })
    },
    sendOrder() {
      axios({
        url: `/my/deliveries/send/${this.carId}`,
        method: 'POST',
        data: {
          zip: this.zip,
          address: this.address,
          city: this.city,
          phone: this.phone,
          contact: this.contact,
          delivery_type: this.deliveryType,
          delivery_id: this.deliveryId,
          is_custom_contacts: this.isCustomAddress,
          price: this.price,
        }
      }).then(resp => {
        const lot = this.arrLots.find(item => item.car_id === this.carId);
        lot.isDelivered = !resp.data.error;
        this.responseMessage = resp.data;
        if (resp.data.error) {
          this.errorMessage = resp.data.message;
        } else {
          this.carId = null;
          this.errorMessage = '';
        }
      }).catch(err => {
        this.errorMessage = err.message ?? err.response?.data?.message ?? ''
      }).finally(() => {
        this.isCustomAddress = false;
      })
    },
    change(params) {
      this.address = params.address;
      this.city = params.city;
      this.phone = params.phone;
      this.zip = params.zip;
      this.contact = params.contact;
      this.deliveryType = params.deliveryType;
      this.deliveryId = params.deliveryId;
      this.isCustomAddress = params.isCustomAddress;
      this.price = params.price;
    },
    getPrice(params) {
      this.requestPrices(params).then(resp => {
        if (resp.data.error || resp.data.errors) {
          this.errorMessage = resp.data.message;
        } else {
          this.errorMessage = '';
          this.deliveries = this.deliveries.filter(item => !item.recalc);
          this.deliveries.push(...resp.data.deliveries);
        }
      }).catch(err => {
        this.errorMessage = err.message ?? err.response?.data?.message ?? ''
      });
    },
    requestPrices(params) {
      this.isLoading = true;
      return axios({
        url: `/my/deliveries/prices/${this.carId}`,
        method: 'POST',
        data: params
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }
}
</script>
